/* eslint-disable complexity */
import type { UDFData } from 'src/udf/udf.validations';
import { type ArgoMaterialUdfDefaultDataInsertInput, type ArgoMaterialUdfDefaultDataUpdates } from '@redviking/argonaut-util/types/db-schema/argo/material_udf_default_data';

type ValidateMaterialModelDefaultDataResponse = {
    deletes: string[];
    updates: ArgoMaterialUdfDefaultDataUpdates[];
    inserts: ArgoMaterialUdfDefaultDataInsertInput[];
};

type MaterialModelUdfCfg = {
    id: string;
    model_number: string;
    material_udf_default_data: UDFData[];
};

export const generateMaterialModelDefaultDataChanges = (payload: {
    newMaterialModel: MaterialModelUdfCfg;
    originalMaterialModel?: MaterialModelUdfCfg;
}): ValidateMaterialModelDefaultDataResponse => {
    const ret: ValidateMaterialModelDefaultDataResponse = {
        deletes: [],
        updates: [],
        inserts: [],
    };
    for (const udfItem of payload.newMaterialModel.material_udf_default_data) {
        if (payload.originalMaterialModel) {
            const originalUdfDefaultItem = payload.originalMaterialModel.material_udf_default_data.find(u => u.id === udfItem.id);
            if (originalUdfDefaultItem) {
                if (originalUdfDefaultItem.num_val !== udfItem.num_val || originalUdfDefaultItem.str_val !== udfItem.str_val) {
                    ret.updates.push({
                        where: {
                            id: { _eq: udfItem.id },
                        },
                        _set: {
                            num_val: udfItem.num_val,
                            str_val: udfItem.str_val,
                        },
                    });
                }
            } else {
                ret.inserts.push({
                    ...udfItem,
                    material_model_id: payload.newMaterialModel.id,
                });
            }
        } else {
            ret.inserts.push({
                ...udfItem,
                material_model_id: payload.newMaterialModel.id,
            });
        }
    }

    if (payload.originalMaterialModel) {
        for (const udfItem of payload.originalMaterialModel.material_udf_default_data) {
            if (!payload.newMaterialModel.material_udf_default_data.find(u => u.id === udfItem.id)) {
                ret.deletes.push(udfItem.id);
            }
        }
    }

    return ret;
};
